export default __webpack_public_path__ + "static/media/mangadraft.de58b7b7.svg";